import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';

@Component({
  selector: 'notification-bar',
  imports: [],
  templateUrl: './notification-bar.component.html',
  styleUrl: './notification-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBarComponent {
  type = input<'success' | 'warning' | 'neutral' | 'error'>('neutral');
  icon = input<string>();
  closable = input<boolean>(false);
  onClose = output<boolean>();

  protected isOpen = signal(true);

  constructor() {
    effect(() => {
      const isOpen = this.isOpen();
      if(!isOpen) {
        this.onClose.emit(true);
      } 
    })
  }
}
